import DisclosureTriggerProvider from './hooks/useDisclosureTrigger';

import { DisclosureTriggerProps } from './@types/DisclosureTriggerProps';

const DisclosureTrigger = (props: DisclosureTriggerProps) => {
	//   const { state } = useDisclosure()
	//   const visible = state?.visible
	//   const htmlProps = {
	//     className: `vtex-disclosure-layout-1-x-trigger vtex-disclosure-layout-1-x-trigger--${props.blockClass} vtex-disclosure-layout-1-x-trigger--${visible ? 'visible' : 'hidden'} vtex-disclosure-layout-1-x-trigger--${props.blockClass}--${visible ? 'visible' : 'hidden'}`
	//   }

	return (
		<DisclosureTriggerProvider {...props}>
			{/* <TriggerVtex
        as={props.as}
        htmlProps={htmlProps}
      > */}
			{props.children}
			{/* </TriggerVtex> */}
			{/* <Icon handle={" "} id="nav-caret--up" size={16} /> */}
		</DisclosureTriggerProvider>
	);
};

export default DisclosureTrigger;
